import { useCallback, useEffect, useState } from 'react';
import { useUserContext } from 'UserContext';
import UserAttributesApi from 'shared/UserAttributesApi';

export const REVIEWED_NOTIFICATION_PREFERENCES_ATTRIBUTE = 'Has Reviewed Notification Preferences';

export function useNotificationPreferencesNudge() {
    const { user } = useUserContext();
    const [reviewed, setReviewed] = useState<boolean>();

    useEffect(() => {
        if (!user?.id) return;

        let current = true;
        UserAttributesApi.exists(REVIEWED_NOTIFICATION_PREFERENCES_ATTRIBUTE)
            .then((exists) => current && setReviewed(exists))
            .catch(() => current && setReviewed(true));
        return () => {
            current = false;
        };
    }, [user?.id]);

    const dismiss = useCallback(() => {
        setReviewed(true);
        UserAttributesApi.create(REVIEWED_NOTIFICATION_PREFERENCES_ATTRIBUTE).catch(() => undefined);
    }, []);

    return { showNudge: reviewed === false, dismiss };
}
